import { serverAddr, fileServerAddr } from "../networkConfig";
export default {
	getPromotions() {
		return serverAddr.get("/promotion/get_promotions/", {});
	},
	getAllCampaigns(params) {
		return serverAddr.post("/promotion/get_all_campaigns/", params);
	},
	getProductListByStore(params) {
		return serverAddr.post(
			"/product/get_shared_products_from_outlets/",
			params
		);
	},
	getProductDetailsByProductId(params) {
		return serverAddr.get(`/product/${params}/`);
	},
	savePromotion(params) {
		return serverAddr.post(`/promotion/add/update/promotion/`, params);
	},
	saveCampaign(params) {
		return serverAddr.post(`/promotion/add/update/campaign/`, params);
	},
	saveCommunication(params) {
		return serverAddr.post(`/promotion/add/update/communication/`, params);
	},
	sendCommunicationForCampaign(params) {
		return serverAddr.post(
			`/promotion/send_communications_for_campaign/`,
			params
		);
	},
	deleteCampaign(params) {
		return serverAddr.post(`/promotion/delete_campaign/`, params);
	},
	getAllPromotions() {
		return serverAddr.get("/promotion/get_all_promotion_type/", {});
	},
	saveCommunicationCSV(params) {
		return fileServerAddr.post(
			"/promotion/csv_upload_for_communication/",
			params
		);
	}
};
